import { observer } from 'mobx-react';
import React, { useEffect } from 'react';
import Skeleton from 'react-loading-skeleton';
import { Link } from 'react-router-dom';
import { SCREENS } from 'src/constants/screens';
import Headers from 'src/view/containers/Headers/Headers';
import HeaderBack from 'src/view/containers/Headers/components/HeaderBack/HeaderBack';
import t360IntegrationStore from 'src/view/screens/SettingsScreen/store/t360IntegrationStore';
import './style.scss';
import ScrollableBlock from '~/view/containers/ScrollableBlock/ScrollableBlock';
import { IT360IntegrationSettings } from '~/types/integrations';
// eslint-disable-next-line max-len
import T360IntegrationSettingsForm from '~/view/screens/SettingsScreen/screens/Integrations/Integrations/components/T360IntegrationSettingsForm/T360IntegrationSettingsForm';
import SpinLoader from '~/view/components/Controls/SpinLoader/SpinLoader';
import { TabLabel } from '~/view/components/Controls/TabLabel/TabLabel';

const T360Screen = observer((): JSX.Element => {
  useEffect(() => {
    t360IntegrationStore.getSettings();
    return () => {
      t360IntegrationStore.unMount();
    };
  }, []);

  return (
    <div className="d-flex flex-column full-width integration-settings-page">
      <Headers>
        <HeaderBack title="Taker360" path={SCREENS.SETTINGS_INTEGRATIONS()} />
      </Headers>
      <div className="t360-screen-container">
        {t360IntegrationStore.isOnLoading ? (
          <div className="t360-screen-container__loader">
            <SpinLoader />
          </div>
        ) : null}
        {t360IntegrationStore.isLoading ? (
          <Skeleton width={200} height={46} className="mt-6" />
        ) : (
          <div className="t360-screen-container__tabs-wrapper">
            {t360IntegrationStore.tabs.map((tab) => (
              <TabLabel
                key={`t360tab-${tab.id}`}
                value={tab.name}
                label={tab.provider}
                onPress={t360IntegrationStore.setActiveTab}
                count={0}
                isActive={t360IntegrationStore.activeTabName === tab.name}
              />
            ))}
          </div>
        )}
        {!t360IntegrationStore.isLoading ? (
          <ScrollableBlock>
            {(t360IntegrationStore.integrationsSettings?.integrations ?? [])
              .filter((integrationSettings) => integrationSettings.name === t360IntegrationStore.activeTabName)
              .map((integrationSettings: IT360IntegrationSettings) => (
                <T360IntegrationSettingsForm
                  integrationSettings={integrationSettings}
                  key={`t360-integration-settings-${integrationSettings.name}`}
                />
              ))}
          </ScrollableBlock>
        ) : (
          <Skeleton width={1050} height={600} className="mt-5" />
        )}
      </div>
    </div>
  );
});

export default T360Screen;
